import { render, staticRenderFns } from "./ReportMealsTakenCompanyMonthlyOrders.vue?vue&type=template&id=44ce5f74"
import script from "./ReportMealsTakenCompanyMonthlyOrders.vue?vue&type=script&lang=js"
export * from "./ReportMealsTakenCompanyMonthlyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports